<template>
  <div class="div-dias-semana">
    <span class="text-datas-number ml-12">
      {{
      totalAnimaisAlocadoDiaPlanta
      }}
    </span>
    <span class="text-datas-extenso ml-1 mr-1">de</span>
    <span class="text-datas-number mr-12">{{ qtTotalDemandNotNull }}</span>
    <br />
    <span class="text-datas-number">
      {{
      textTotalDemandFilled
      }}
    </span>
  </div>
</template>

<script>
export default {
  name: "CardItemTotalDemand",
  props: {
    itemData: {
      type: Object,
      default: {},
    },
    itemPlanta: {
      type: Object,
      default: {},
    },
    listaLotes: {
      type: Array,
      default: [],
    },
    qtTotalDemand: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    totalAnimaisAlocadoDiaPlanta() {
      let listaFiltrada = this.listaLotes.filter(
        (x) =>
          x.cdPlantaAbate == this.itemPlanta.cdPlantaAbate &&
          x.stDiaAlocado == this.itemData.value &&
          !x.blDeleted
      );

      let total = 0;
      listaFiltrada.forEach((item) => {
        total = parseInt(total) + (parseInt(item.qtAnimaisAlocados) | 0);
      });

      return total;
    },
    qtTotalDemandNotNull() {
      if (!this.qtTotalDemand) return 0;
      return this.qtTotalDemand;
    },
    textTotalDemandFilled() {
      let diff = this.qtTotalDemandNotNull - this.totalAnimaisAlocadoDiaPlanta;
      if (diff < 0) {
        return "Sobrando " + Math.abs(diff);
      } else if (diff === 0) {
        return "Demanda completa";
      } else {
        return "Faltam " + Math.abs(diff);
      }
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
